import {close_modal, loading} from "../functions/functions";

export function show_front_expert_orders()
{
    if( document.querySelector(".js_show_front_expert_orders_button")!==null && document.querySelector(".js_show_front_expert_orders_button")!==undefined ) {
        let showAllOrdersButton = document.querySelectorAll( '.js_show_front_expert_orders_button' );
        let expertsModal = document.querySelector( '.experts_modal_container' );
        showAllOrdersButton.forEach( button => {
            button.addEventListener( 'click', event => {
                event.preventDefault();
                expertsModal.classList.add( 'show_modal' );
                document.querySelector( '.js_expert_order_title' ).innerText=button.dataset.title;
                document.querySelector( '.body.js_show_front_expert_orders' ).innerHTML = loading();
                jQuery.ajax({
                    url : button.dataset.url,
                    method : "POST",
                    data : {
                        action : button.dataset.action,
                        nonce : button.dataset.nonce,
                        projectID : button.dataset.projectid,
                        tableType : button.dataset.tabletype,
                        for_page : button.dataset.for,
                    },
                    error: ( res )=>{
                        console.log( "ERROR RES :" );
                        console.log( res );
                    },
                    success: ( res )=>{
                        document.querySelector( '.body.js_show_front_expert_orders' ).innerHTML = res;
                    }
                });
            } );
        } );
        close_modal();
    }
}